export enum PieceType {
  None,
  WhitePawn,
  WhiteKnight,
  WhiteBishop,
  WhiteRook,
  WhiteQueen,
  WhiteKing,
  BlackPawn,
  BlackKnight,
  BlackBishop,
  BlackRook,
  BlackQueen,
  BlackKing
}

export enum Colour {
  White = "White",
  Black = "Black"
}

export const BoardSize = 8;